import { createSlice } from '@reduxjs/toolkit';
const domainSlice = createSlice({
  name: 'selectedDomain',
  initialState: {},
  reducers: {
    setDomain: (_, { payload }) => {
      return payload;
    },
    remDomain: state => {
      return {};
    }
  }
});
export const { setDomain, remDomain } = domainSlice.actions;
export default domainSlice;
